// src/components/PostManagerModal.jsx
import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { firestore } from '../views/firebaseConfig';
import { useAuth } from '../contexts/AuthContext';
import EditPostModal from '../components/EditPostModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp, faThumbsDown, faEye } from '@fortawesome/free-solid-svg-icons';
import './PostManagerModal.css';

export default function PostManagerModal({ onClose, onCreate }) {
  const { user } = useAuth();
  const userId = user?.uid;
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);

  useEffect(() => {
    if (!userId) return;
    (async () => {
      setLoading(true);
      const snap = await getDocs(
        query(
          collection(firestore, 'feedPost'),
          where('userId', '==', userId),
          where('status', '!=', 'deleted')
        )
      );
      setPosts(snap.docs.map(d => {
        const data = d.data();
        return {
          id: d.id,
          feedPostId: data.feedPostId || d.id,
          postTitle: data.postTitle || '',
          postText: data.postText || '',
          image1: data.image1 || '',
          image2: data.image2 || '',
          image3: data.image3 || '',
          category: data.category || '',
          postlikes: Array.isArray(data.postlikes) ? data.postlikes : [],
          postdislikes: Array.isArray(data.postdislikes) ? data.postdislikes : [],
          views: typeof data.views === 'number' ? data.views : 0,
          timestamp: data.timestamp,
          isBusinessPost: !!data.isBusinessPost,
          status: data.status || '',
          locationId: data.locationId || null,
          businessId: data.businessId || null,
          nickname: data.nickname || '',
          userImage: data.userImage || '',
          userId: data.userId || userId
        };
      }));
      setLoading(false);
    })();
  }, [userId]);

  const daysVisible = ts => {
    const created = ts?.toDate?.() || ts;
    return Math.floor((Date.now() - new Date(created).getTime()) / 86400000);
  };

  return (
    <>
      <Modal
        show={true}
        onHide={onClose}
        size="lg"
        centered
        scrollable
        backdropClassName="pmm-backdrop"
        dialogClassName="pmm-dialog modal-dialog-scrollable"
      >
        <Modal.Header closeButton>
          <Modal.Title>📝 Pockit Manager</Modal.Title>
        </Modal.Header>

        <Modal.Body className="pmm-list">
          {loading ? (
            <div className="pmm-empty">Loading…</div>
          ) : posts.length === 0 ? (
            <div className="pmm-empty">No posts found.</div>
          ) : (
            posts.map(post => (
              <div
                key={post.id}
                className="pmm-item"
                onClick={() => setEditing(post)}
              >
                <img className="pmm-thumb" src={post.image1 || ''} alt="" />
                <div className="pmm-title">{post.postTitle}</div>
                <div className="pmm-sub">{post.postText.slice(0, 60)}…</div>
                <div className={`pmm-status-pill ${post.status.toLowerCase()}`}>
                  {post.status}
                </div>
                <div className="pmm-metrics">
                  <FontAwesomeIcon icon={faThumbsUp} /><span>{post.postlikes.length}</span>
                  <FontAwesomeIcon icon={faThumbsDown} /><span>{post.postdislikes.length}</span>
                  <FontAwesomeIcon icon={faEye} /><span>{post.views}</span>
                </div>
                <div className="pmm-days">{daysVisible(post.timestamp)}d</div>
              </div>
            ))
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>Close</Button>
          <Button variant="primary" onClick={onCreate}>New +</Button>
        </Modal.Footer>
      </Modal>

      {editing && (
        <EditPostModal
          show={true}
          post={editing}
          onHide={() => setEditing(null)}
          onUpdated={() => setEditing(null)}
        />
      )}
    </>
  );
}
